import { Button, Input } from "antd";
import { ReactNode } from "react";
import AddIcon from "../../../assets/icons/AddIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import useModal from "../../../hooks/useModal";
import { ChatListResponse } from "../../../types/chat";
import Loader from "../../ui/Loader";
import ConversationItem from "./ConversationItem";
import NewChatModal from "./NewChatModal";

export default function MessageWrapper({
  children,
  oneToOneChatListData,
  isLoading,
  setSearch,
  setType,
  type,
}: {
  children: ReactNode;
  oneToOneChatListData?: ChatListResponse;
  isLoading?: boolean;
  setSearch?: (search: string) => void;
  setType?: (type: string) => void;
  type?: string;
}) {
  const {
    open: openNewChatModal,
    handleOpen: handleNewChatOpen,
    handleClose: handleNewChatClose,
  } = useModal<undefined, "NEW_CHAT">();

  return (
    <div className="grid grid-cols-7">
      {openNewChatModal.type === "NEW_CHAT" && (
        <NewChatModal
          open={openNewChatModal.open}
          handleClose={handleNewChatClose}
        />
      )}
      <div className="col-span-2 px-4">
        <div className="flex gap-2">
          <Input
            placeholder="Search"
            prefix={<SearchIcon />}
            onChange={(e) => setSearch?.(e.target.value)}
          />
          <Button onClick={() => handleNewChatOpen({ type: "NEW_CHAT" })}>
            <AddIcon />
          </Button>
        </div>

        <div className="flex gap-2 items-start mt-2">
          <Button
            onClick={() => setType?.("")}
            className={
              type === ""
                ? "!bg-[#FE7235] text-white"
                : "bg-gray-200 text-black"
            }
          >
            All
          </Button>
          <Button
            onClick={() => setType?.("group")}
            className={
              type === "group"
                ? "!bg-[#FE7235] text-white"
                : "bg-gray-200 text-black"
            }
          >
            Groups
          </Button>
        </div>

        <div className="mt-4 max-h-[calc(100vh-14.5rem)] overflow-y-auto">
          {isLoading ? (
            <Loader />
          ) : (
            oneToOneChatListData?.data?.map((conversation, indx) => (
              <ConversationItem
                key={indx}
                conversation={conversation}
              />
            ))
          )}
        </div>
      </div>
      <div className="col-span-5">{children}</div>
    </div>
  );
}
